import { message, Modal } from "antd";
import { useEffect } from "react";
import { ExclamationCircleFilled } from "@ant-design/icons";
const { confirm } = Modal;
const mode = "real";
const PAYMENT_APIKEY =
  "9c4e2a7f0b6d138e5a1c9f3b7d2e84605c8a1f3e9b0d472a6f1c5e8d3b9a204f";
const PAYMENT_SECRET =
  "4e8b2f6a0c9d1e573b5f8a2c6e0d4917b3f7a1c5e9d2840b6f1a3c7e5b9d0248f2a6c0e4b8d1f593a7c5e0b2d4f6810a3c9e7b5d1f0a4c8e2b6d3f59071a4c6e8";

const API_URL = {
  test: "http://10.150.10.72:9090/api",
  real: "https://api.ezstart.mn/api",
};

const API_URL_IMAGE = {
  test: "http://10.150.10.28:9090",
  real: "https://api.ezstart.mn",
};

const SOCKET_URL = {
  real: "https://socket.ezstart.mn/api",
  test: "https://socket.ezstart.mn/api",
};

const PAYMENT_URL = {
  real: "https://merchant.onispos.mn/api",
  test: "https://merchant.onispos.mn/api",
};

const CAR_URL = {
  real: "https://xyp-api.smartcar.mn/xyp-api/v1/xyp/get-data-public",
  test: "https://xyp-api.smartcar.mn/xyp-api/v1/xyp/get-data-public",
};

const URLS = {
  main: API_URL[mode],
  socket: SOCKET_URL[mode],
  payment: PAYMENT_URL[mode],
  car: CAR_URL[mode],
  image: API_URL_IMAGE[mode],
};

const islogged = (props) => {
  if (props?._auth && props?.islogin) return true;
  return false;
};

const isShow = (props) => {
  const { pathname } = window.location;
  if (
    pathname.includes("login") ||
    pathname.includes("register") ||
    pathname.includes("biometrics") ||
    pathname.includes("qrpage")
  )
    return false;
  return islogged(props) ? true : false;
};

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

const beforeUpload = (file) => {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!");
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("Image must smaller than 2MB!");
  }
  return isJpgOrPng && isLt2M;
};

const saveLoginData = ({ values, data }) => {
  localStorage.setItem("access_token", data?.access_token);
  localStorage.setItem("auth", JSON.stringify(data));
  if (values?.checkbox) localStorage.setItem("name", values?.name);
  else localStorage.removeItem("name");
};

const licenseModal = (navigate, translate) => {
  confirm({
    title: translate("main.licensesms"),
    icon: <ExclamationCircleFilled />,
    content: translate("main.licensedesc"),
    maskClosable: true,
    centered: true,
    cancelText: translate("main.close"),
    okText: translate("main.buy"),
    onOk() {
      navigate("/license");
    },
  });
};

const cancelInvoice = (cancel) => {
  confirm({
    title: "Анхааруулга.",
    icon: <ExclamationCircleFilled />,
    content: "Нэхэмжлэх үүсэгсэн байна. Цуцлах уу ?",
    maskClosable: true,
    centered: true,
    cancelText: "Үгүй",
    okText: "Тийм",
    onOk() {
      cancel && cancel();
    },
  });
};

const postMessageMobile = (data) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
  }
};

const useMobileEvent = (func) => {
  useEffect(() => {
    const device = localStorage.getItem("deviceType");
    if (device === "ios" || device === "android") {
      if (device === "ios") window.addEventListener("message", func);
      else document.addEventListener("message", func);

      return function cleanupListener() {
        if (device === "ios") window.removeEventListener("message", func);
        else document.removeEventListener("message", func);
      };
    }
  }, [func]);
};

const convertTime = (hour, minute) => {
  let hours = hour ? hour.toString()?.padStart(2, "0") : "00";
  let minutes = minute ? minute.toString()?.padStart(2, "0") : "00";
  return `${hours}:${minutes}`;
};

export {
  URLS,
  islogged,
  isShow,
  getBase64,
  beforeUpload,
  saveLoginData,
  licenseModal,
  cancelInvoice,
  useMobileEvent,
  postMessageMobile,
  convertTime,
  PAYMENT_APIKEY,
  PAYMENT_SECRET,
};
